import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton, SecondaryButton } from '../common/Buttons';
import './style.css';

export default function HeroSection() {
  return (
    <section className="hero-gradient pt-5 pb-5 text-white position-relative overflow-hidden">
      <div className="hero-overlay"></div>
      <Container className="position-relative" style={{ zIndex: 2 }}>
        <Row className="justify-content-center">
          <Col md="10" lg="8" className="text-center">
            <h1 className="display-4 fw-bold mb-4">
              Get The Website Your Business{" "}
              <span className="text-warning">Deserves</span>
            </h1>
            <p className="lead mb-4">
              Stop losing customers to competitors with better websites. Get a professional, fast-loading site that actually brings in business – starting at just $399.
            </p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <PrimaryButton
                href="#portfolio"
                className="px-5 py-3 fw-semibold"
                size="lg"
              >
                See Our Work
              </PrimaryButton>
              <SecondaryButton
                href="#quote"
                className="px-5 py-3 fw-semibold"
                size="lg"
              >
                Get Your Quote
              </SecondaryButton>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
